import styled from 'styled-components';
import { ColorConstants, FontFamilyConstants } from '@shared/constants';

export const HeaderSubtitle = styled.p`
    color: ${ColorConstants.padua};
    font-family: ${FontFamilyConstants.Helvetica};
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
`;

export const Text = styled.p`
    font-size: 14px;
    color: ${ColorConstants['regal-blue-50%']};
    font-weight: 400;
`;

export const SegmentSelectedContainer = styled.div`
    margin-bottom: -8px;
`;

export const StartIcon = styled.span`
    height: 16px;
    width: 16px;
    border-radius: 5px;
    background-color: ${props => props.backgroundColor};
    color: ${ColorConstants.white};
    font-weight: 700;
    font-size: 9px;
    font-family: ${FontFamilyConstants.Helvetica};
    display: flex;
    align-items: center;
    justify-content: center;
`;
